import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Heading, View } from '@aws-amplify/ui-react';
import FileList from './components/FileList';
import FileViewer from './components/FileViewer';
import PlaylistViewer from './components/PlaylistViewer';

function App() {
  return (
    <View padding="0.25rem" style={{ backgroundColor: "#FFF3E0" }}>
      <View padding="0.25rem">
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.25rem' }}>
          <img 
            src="/images/radha_krishna.jpg" 
            alt="Radha Krishna" 
            style={{ height: '3rem', marginRight: 'auto' }} 
          />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '2rem', marginRight: '0.5rem' }}>📚</span>
            <Heading level={1} style={{ 
              margin: 0, 
              background: 'linear-gradient(45deg,rgb(112, 69, 4), #F48FB1)', 
              WebkitBackgroundClip: 'text', 
              WebkitTextFillColor: 'transparent',
              textShadow: '0 1px 0 rgba(0,0,0,0.2), 0 0 3px rgba(0,0,0,0.1)',
              fontStyle: 'italic',
              fontSize: '1.3rem',
              fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
              letterSpacing: '1px',
              textShadow: '0px 1px 2px rgba(0,0,0,0.1)',
              fontWeight: '800'
            }}>
              Namapages
            </Heading>
          </div>
          <img 
            src="/images/vittal_rakhumayi.jpg" 
            alt="Vittal Rakhumayi" 
            style={{ height: '3rem', marginLeft: 'auto' }} 
          />
        </div>
      </View>
      
      <Routes>
        <Route path="/" element={<FileList />} />
        <Route path="/file/:folder/:language/:fileName" element={<FileViewer />} />
        <Route path="/playlist/:playlistId" element={<PlaylistViewer />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </View>
  );
}

export default App;